// src/api/userService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL + '/auth';

// Get all users (Admin only)
export const getAllUsers = async () => {
  try {
    const response = await axios.get(`${API_URL}/admin/users`);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

// Update user password (Admin only)
export const updateUserPassword = async (userId, newPassword) => {
  try {
    const response = await axios.post(`${API_URL}/admin/users/${userId}/password`, {
      new_password: newPassword
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user password:', error);
    throw error;
  }
};

// Delete user (Admin only)
export const deleteUser = async (userId) => {
  try {
    const response = await axios.delete(`${API_URL}/admin/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};

// Update user role (Admin only)
export const updateUserRole = async (userId, newRole) => {
  try {
    const response = await axios.post(`${API_URL}/admin/users/${userId}/role`, {
      role: newRole
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user role:', error);
    throw error;
  }
};

// Toggle user status (Admin only)
export const toggleUserStatus = async (userId, disabled) => {
  try {
    const response = await axios.post(`${API_URL}/admin/users/${userId}/status`, {
      disabled: disabled
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user status:', error);
    throw error;
  }
};